module.exports = "\r\n  <router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/auth/auth-layout.component.html
// module id = ./src/app/layouts/auth/auth-layout.component.html
// module chunks = main